// ExistingCustomerStep1.jsx
import React from 'react'
import PropTypes from 'prop-types'

import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'

import {
  CapitalButton,
} from '../../Navigation/Buttons'

import ModemLocationDefault from '../../Graphics/ModemSwapGraphics/ModemLocation'
import DetachAntennaDefault from '../../Graphics/ModemSwapGraphics/DetachAntenna'
import RemoveModemDefault from '../../Graphics/ModemSwapGraphics/RemoveModem'

// HOC
import withAppStore from '../../../../util/withAppStore'

import styles from '../../../../../css/home.module.css'
import settingStyles from '../../../../../css/settings.module.css'

const ModemReplacementStep2 = ({
  intl: { formatMessage },
  nextPage,
  skipInstructions,
}) => {
  return (
    <div>
      {skipInstructions}
      <div className={`${styles.userInviteInput} ${settingStyles.modemReplacementContainer}`}>
        <FormattedMessage
          id='settings.modemReplacement.removeModem'
          defaultMessage='REMOVING THE 3G MODEM: '
          description='Remove Modem label'
          tagName='h3'
        />

        <div className={settingStyles.modemReplacementIntro}>
          <p>
            <FormattedMessage
              id='settings.modemReplacement.disconnectingPowerIntro'
              defaultMessage='Video and text instructions available '
              description='Diconnecting Power Intro label'
            />
            <a className={styles.replacementLink} href='https://altrac.zendesk.com/hc/en-us/articles/360038363473-ST100-Repair-Maintenance' target='_blank' rel='noreferrer'>
              <FormattedMessage
                id='settings.modemReplacement.hereLink'
                defaultMessage='here'
                description='Here Link label'
              />
              .
            </a>
          </p>
        </div>
        <div className={settingStyles.ModemSVGWrapper}>
          <ModemLocationDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.stepTwo-1'
          defaultMessage='1. Locate the modem, a raised rectangular part on the  PCB.'
          description='Step Two One label'
          tagName='p'
        />
        <div className={settingStyles.ModemSVGWrapper}>
          <DetachAntennaDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.stepTwo-2'
          defaultMessage='2. Detach the antenna by holding the connector and gently pull away from the PCB.'
          description='Step Two Two label'
          tagName='p'
        />
        <div className={settingStyles.ModemSVGWrapper}>
          <RemoveModemDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.stepTwo-3'
          defaultMessage='3. Use one hand to grab the modem at the top and bottom and pull away from the PCB to remove the modem.'
          description='Step Two Three label'
          tagName='p'
        />

      </div>

      <CapitalButton
        text={formatMessage({
          id: 'customer.nextButton',
          defaultMessage: 'Next',
          description: '',
        })}
        buttonFunction={nextPage}
        hSize='h2'
        style={`${styles.saveButton} saveButton`}
      />
    </div>
  )
}

ModemReplacementStep2.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  nextPage: PropTypes.func.isRequired,
  skipInstructions: PropTypes.node,
}

export default withAppStore(injectIntl(ModemReplacementStep2))
